import { ClienteDTO } from "@DTOS";

export namespace ClientesAcciones {
    export class Obtener {
        static readonly type = "[Clientes] ObtenerTodo clientes";
    }

    export class ObtenerId {
        static readonly type = "[Clientes] ObtenerTodo clientes por id";

        constructor(public id: number) {}
    }

    export class PedirEntidades {
        static readonly type = "[Clientes] Pedir entidades";
        constructor(public accion: new (clientes: ClienteDTO[]) => any) {}
    }

    export class Filtrar {
        static readonly type = "[Clientes] Filtrar clientes";

        constructor(public filtroFuncion: (cliente: ClienteDTO) => boolean) {}
    }

    export class Ordenar {
        static readonly type = "[Clientes] Ordenar clientes";

        constructor(public ordenFuncion: (a: ClienteDTO, b: ClienteDTO) => number) {}
    }

    export class Agregar {
        static readonly type = "[Clientes] Agregar clientes";

        constructor(public cliente: ClienteDTO) {}
    }

    export class Actualizar {
        static readonly type = "[Clientes] Actualizar clientes";

        constructor(public cliente: ClienteDTO) {}
    }

    export class Borrar {
        static readonly type = "[Clientes] Borrar clientes";

        constructor(public cliente: ClienteDTO) {}
    }

    export class LimpiarEstadoAccion {
        static readonly type = "[Clientes] Limpiar estado accion clientes";
    }

    export class ObtenerTemplates {
        static readonly type = "[Clientes] Obtener templates";
    }
}
